import { createSlice } from '@reduxjs/toolkit'

const ui = createSlice({
  name: 'ui',
  initialState: {
    newAppDialogVisible: false
  },
  reducers: {
    toggleNewApplicationDialog: ( state, action ) => {
      state.newAppDialogVisible = action.payload
    }
  }
})

export const getNewApplicationDialogState = state => state.ui.newAppDialogVisible


export default ui